import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './xueyuan.module.css';

import badgeYuyan from "../../../img/badge_yuyan.png";

import badgeTiyu from "../../../img/badge_tiyu.png";
import badgeYishu from "../../../img/badge_yishu.png";
import badgeShuxue from "../../../img/badge_shuxue.png";
import badgeLaodong from "../../../img/badge_laodong.png";
import badgePinde from "../../../img/badge_pinde.png";
import defaultImg from '../../../img/bee.svg';
import badgeCenter from "../../../img/badge_center.svg";
import huizhang from "../../../img/huizhang.svg";
import dianzan from "../../../img/ic_dianzan.svg";
import {getStudentXueyuanBadge} from "../../../service/student";

class Xueyuan extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, []);

        this.state = {
            huizhang_num: '',
            dianzan_num: '',
            class_dianzan: '',
            class_gaijin: '',
            renwen: [],
            laodong: [],
            pinde: [],
            tiyu: [],
            shuxue: [],
            yishu: [],
        };

    }

    componentDidMount() {
        getStudentXueyuanBadge(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)
            if (data.ret == '1') {

                this.setState({
                    // huizhang_num: data.data.st_hz,
                    // dianzan_num: data.data.st_dz,
                    // class_dianzan: data.data.class_dianzan,
                    // class_gaijin: data.data.class_gaijin,
                    renwen: data.data.xueyuan.renwen,
                    laodong: data.data.xueyuan.laodong,
                    pinde: data.data.xueyuan.pinde,
                    tiyu: data.data.xueyuan.tiyu,
                    shuxue: data.data.xueyuan.shuxue,
                    yishu: data.data.xueyuan.yishu
                });
            }
        });
    }

    render() {
        return (
            <div className={styles.root} >
                <div className={styles["container-fengchao"]}>
                    <img className={styles["badge-yuyan"]}
                         src={badgeYuyan}/>
                    <img className={styles["badge-center"]} src={badgeCenter}/>
                    <img className={styles["badge-laodong"]} src={badgeLaodong}/>
                    <img className={styles["badge-pinde"]} src={badgePinde}/>
                    <img className={styles["badge-tiyu"]} src={badgeTiyu}/>
                    <img className={styles["badge-shuxue"]} src={badgeShuxue}/>
                    <img className={styles["badge-yishu"]} src={badgeYishu}/>
                    {/*语言与人文*/}
                    <div className={styles["div-badge-yuyan"]}>
                        <div className={styles["text-tongji-num"]}>{this.state.renwen[0]}</div>
                        <img className={styles["img-dianzan"]} src={huizhang}/>
                    </div>
                    <div className={styles["div-dianzan-yuyan"]}>
                        <img className={styles["img-dianzan"]} src={dianzan}/>
                        <div className={styles["text-tongji-num"]}>{this.state.renwen[1]}</div>
                    </div>
                    {/*劳动与科创*/}
                    <div className={styles["div-badge-laodong"]}>
                        <img className={styles["img-dianzan"]} src={huizhang}/>
                        <div className={styles["text-tongji-num"]}>{this.state.laodong[0]}</div>
                    </div>
                    <div className={styles["div-dianzan-laodong"]}>
                        <img className={styles["img-dianzan"]} src={dianzan}/>
                        <div className={styles["text-tongji-num"]}>{this.state.laodong[1]}</div>
                    </div>

                    {/*品德与修养*/}
                    <div className={styles["div-badge-pinde"]}>
                        <img className={styles["img-dianzan"]} src={huizhang}/>
                        <div className={styles["text-tongji-num"]}>{this.state.pinde[0]}</div>
                    </div>
                    <div className={styles["div-dianzan-pinde"]}>
                        <img className={styles["img-dianzan"]} src={dianzan}/>
                        <div className={styles["text-tongji-num"]}>{this.state.pinde[1]}</div>
                    </div>
                    {/*体育与健康*/}
                    <div className={styles["div-badge-tiyu"]}>
                        <div className={styles["text-tongji-num"]}>{this.state.tiyu[0]}</div>
                        <img className={styles["img-dianzan"]} src={huizhang}/>
                    </div>
                    <div className={styles["div-dianzan-tiyu"]}>
                        <img className={styles["img-dianzan"]} src={dianzan}/>
                        <div className={styles["text-tongji-num"]}>{this.state.tiyu[1]}</div>
                    </div>
                    {/*数学与思维*/}
                    <div className={styles["div-badge-shuxue"]}>
                        <div className={styles["text-tongji-num"]}>{this.state.shuxue[0]}</div>
                        <img className={styles["img-dianzan"]} src={huizhang}/>
                    </div>
                    <div className={styles["div-dianzan-shuxue"]}>
                        <div className={styles["text-tongji-num"]}>{this.state.shuxue[1]}</div>
                        <img className={styles["img-dianzan"]} src={dianzan}/>
                    </div>

                    {/*艺术与审美*/}
                    <div className={styles["div-badge-yishu"]}>
                        <div className={styles["text-tongji-num"]}>{this.state.yishu[0]}</div>
                        <img className={styles["img-dianzan"]} src={huizhang}/>
                    </div>
                    <div className={styles["div-dianzan-yishu"]}>
                        <div className={styles["text-tongji-num"]}>{this.state.yishu[1]}</div>
                        <img className={styles["img-dianzan"]} src={dianzan}/>
                    </div>
                </div>

            </div>
        );
    }
}


export default Xueyuan;
